import { render, staticRenderFns } from "./relatorioCard.vue?vue&type=template&id=28c063ed&scoped=true"
import script from "./relatorioCard.vue?vue&type=script&lang=js"
export * from "./relatorioCard.vue?vue&type=script&lang=js"
import style0 from "./relatorioCard.vue?vue&type=style&index=0&id=28c063ed&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28c063ed",
  null
  
)

export default component.exports